import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "onClick", "isPrimary", "isDanger", "className", "disabled", "isLoading", "type", "dataTestId"];
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
var Button = function Button(props) {
  var children = props.children,
    onClick = props.onClick,
    isPrimary = props.isPrimary,
    isDanger = props.isDanger,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    disabled = props.disabled,
    isLoading = props.isLoading,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type,
    dataTestId = props.dataTestId,
    rest = _objectWithoutProperties(props, _excluded);
  var isDisabled = Boolean(disabled || isLoading);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type
  }, rest, {
    onClick: onClick,
    disabled: isDisabled,
    className: classNames("inline-flex items-center justify-center text-base font-medium rounded-6 " + "hover:transition-colors duration-700 text-gray-100 py-4 px-4 outline-none touch-manipulation", _defineProperty({
      "bg-teal-500 hover:bg-teal-600": isPrimary,
      "bg-gray-700 hover:bg-gray-600": !isPrimary,
      "bg-red-600 hover:bg-red-500": isDanger,
      "cursor-progress": isLoading,
      "opacity-50": disabled || isLoading,
      "hover:bg-teal-500": disabled && isPrimary,
      "hover:bg-gray-700": disabled && !isPrimary,
      "hover:bg-red-600": disabled && isDanger
    }, className, !!className)),
    "data-testid": dataTestId
  }), isLoading && /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-5 h-5 rounded-full text-blue-600 mr-3",
    role: "status"
  }), !!children && children);
};
export default Button;